import { getIndustryQualifier } from '../../data/industryTaxonomy';

const k = {
  font: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

export function KioskFooter({ industry }: { industry?: string | null }) {
  const qualifier = industry ? getIndustryQualifier(industry) : null;
  const label = qualifier ? `Powered by CrewBit ${qualifier}` : 'Powered by CrewBit';

  return (
    <div style={{
      textAlign: 'center', padding: '12px 24px',
      fontFamily: k.font, fontSize: 12, color: '#ADB5BD',
      borderTop: '1px solid #F1F3F5',
    }}>
      <a href="https://crewbit.ca" target="_blank" rel="noopener noreferrer" style={{
        color: '#ADB5BD', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4,
      }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#ADB5BD">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
        {label}
      </a>
    </div>
  );
}
